import {
  FormControl, InputLabel, MenuItem, Select,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ErrorBag } from 'src/models/ErrorModel';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { v4 as uuid } from 'uuid';
import { FORM_ID } from 'src/models/FormModel';
import { CSSProperties } from 'react';

export interface SelectItem {
  id?: number | string,
  text: string,
}
//
interface Props {
  disabled?: boolean;
  form: FORM_ID;
  id?: string;
  items: Array<SelectItem>;
  label: string;
  name: string;
  onChange:any;
  value: string | number | undefined;
  margin?: 'dense' | 'normal' | undefined,
  noMarginTop?: boolean,
  style?: CSSProperties,
}

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 220,
    width: '100%',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  selectElement: {
    width: '100%',
  },
  selectLabel: {
    color: 'rgba(0, 0, 0, 0.50)',
  },
  selectLabelError: {
    color: theme.palette.error.main,
  },
}));

const FormSingleSelect = (props:Props) => {
  const {
    disabled, form, id, items, label, name, onChange, value, margin, noMarginTop, style,
  } = props;
  const classes = useStyles();
  const errors: ErrorBag =
    useSelector((state:Store) => state.errors[form] || {} as ErrorBag);

  const onClickItem = (itemValue: string | number | undefined) => {
    if (value === itemValue) {
      onChange('', name);
    }
  };

  const renderItems = () => {
    const elements = [] as any[];
    if (!items) {
      return items;
    }
    items.map((item) => {
      elements.push(
        <MenuItem
          id={`${id}-${item.id}-option`}
          key={uuid()}
          value={item.id}
          selected={item.id === value}
          onClick={() => onClickItem(item.id)}>
          { item.text }
        </MenuItem>,
      );
      return elements;
    });
    return elements;
  };

  let renderClass = '';
  if (!value) {
    renderClass = classes.selectLabel;
  }
  if (errors[name]) {
    renderClass = classes.selectLabelError;
  }

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      error={!!errors[name]}
      key={`form-control-${name}`}
      margin={margin || 'normal'}
      style={style}>
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        id={id}
        value={value}
        labelId={`${id}-label`}
        inputProps={{ id: `${id}-input` }}
        onChange={(e) => onChange(e.target.value as number, name)}
        displayEmpty
        className={`${noMarginTop ? '' : classes.selectEmpty} ${renderClass} ${classes.selectElement}`}
        disabled={disabled}
        key={`select-${name}`}
        label={label}>
        { renderItems() }
      </Select>
    </FormControl>
  );
};

export default FormSingleSelect;
